import React, { useEffect, useRef, useState } from "react";

export default function SpecificationViewed(props) {
  const [foodAndBeverageVisible, setFoodAndBeverageVisible] = useState(false);
  const foodAndBeverageRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setFoodAndBeverageVisible(true);
          observer.disconnect(); // Stop observing once visible
        }
      },
      { threshold: 0.3 }
    );

    if (foodAndBeverageRef.current) {
      observer.observe(foodAndBeverageRef.current);
    }

    return () => observer.disconnect();
  }, []);
  return (
    <div
      style={{ display: "flex" }}
      className="foodBeverageContainer"
      ref={foodAndBeverageRef}
    >
      {props.foodAndBeverage1?.map((productDetail, index) => {
        return (
          <div className="foodAndBeverageInnerContainer" key={index}>
            <div
              className="foodBeverageImgContainer"
              onClick={() => {
                window.location.href = productDetail.pageNavigate;
              }}
            >
              <img
                className={`foodAndBeverageImg1 ${
                  foodAndBeverageVisible ? "animated" : ""
                }`}
                src={productDetail?.productImg}
                alt=""
              />
            </div>
            <div
              className={`foodAndBeverageName ${
                foodAndBeverageVisible ? "animated" : ""
              }`}
            >
              {productDetail?.label}
            </div>
          </div>
        );
      })}
    </div>
  );
}
